module.exports = __webpack_public_path__ + "img/bingo_ball-74.7e9c5921.png";